"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_Y = 0; // 默认的 y 的值
// 偏移之后，间距
exports.MARGIN_RATIO = 1 / 2;
exports.DODGE_RATIO = 1 / 2;
// 散点分开之后，距离边界的距离
exports.GAP = 0.05;
//# sourceMappingURL=constant.js.map